module.exports = __webpack_public_path__ + "src/assets/textures/env/hut/trough_01_512_BAKE.png";